<template>
  <div id="app">
    <!--页面返回不刷新-->
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive> -->
    <router-view v-if="RouterState" :key="this.$route.path"></router-view>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "App",
  provide(){
    return{
      reload:this.reload
    }
  },
  data(){
    return{
      RouterState:true
    }
  },
  methods:{
    reload(){
      this.RouterState = false;
      this.$nextTick(()=>{
        this.RouterState = true
      })
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #1f1f1f;
  /* margin-top: 60px; */
  height: 100%;
}
body,html{
    height: 100%;

}
.m-calendar .m-months-container .m-months-wrapper .m-months .m-row .m-day .m-select {
    background: #9ce17a !important;
    color: #fff !important;
}
.m-calendar .m-toolbar .m-month-selector .m-prev-btn, .m-calendar .m-toolbar .m-year-selector .m-prev-btn{
  background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADj0lEQVRoQ+2ZT0wcVRzHv78FWuCgZ2q9GK+UEE89KtGjMU3aBQpN9GLUUgV2Z2f5M/NmEZndGSGB1iYkuhIaD5roAZs0/ol60ZhorNGb6aFRU05tYyKU7u78mlkh7r6lB2bmDWzKnOdNPp/3e7/3+703hCZ/qMn5cSiw3xE8jMAjHYGMsPs9YBDAUwx+yxXZr/Y6Ifu2hDSRP8/MSzXA3zqW/mxTCGhiTjCTKcFedyy998ALpIV9EYw36kAJJSBxyhHa5wdWYHR0vqP18VIRzEkJcp2Yhgq5zNd7hfffjyUHxibffrKlrbUIRl89JP0OlIcda/J6EPhYBMam53oTREUi9NRD8ndEiaGCyPwVFF65gGbkn/fgFYnoiVpIBj7dut05uLR0YSsMvFKBtFEYALwiCEelZbPsWJlXw4LvjFeSA2nDHgFhUYZk8JxrZSeiglcSgbRpWwCMBnjCuCv0+SjhIxfQzPwlBr8uQxLTuUIusxo1fGQCpmke2eD2KyA6LUHeBSUGHKFdUwEfiYBm5o8x8xUQ6vsYxo2WVk7aRvZnVfChBVLCOUFexYfvllqDH71SOfnu7NRNlfChBDQj3+eBV4nQVbfHM67+k7h3ZlmIDdXwgQU08c5L7CU+BqFNgvzQsfSX4wAPVQfSpv0TgGfqZp7IcUVGixM+cATSZv57gE/WC7DjimxzCDxsCTGh6Ar9lTijELiVSIm554jJL07HpB1orfzYkeTC2NhmHCKBBXy4TM7u5gpWGXKrTD9U2lqT81Pjf6qWCCXgw03MLnSVtrZWQfJhBX+0tFQL2S8qJUIL+HB+K7GJjhUG+qXldIeIkgUz86UqiUgEduDSwl4EY0SGZcJZV+gfqZCIVMAHTAvbAMNvqeseJu9NV0w0nBHCSkUuUJUw7NdAeK9RgmdckW04K4SRUCLgA6WEfYYYKwDapby47Ai94cwQVEKZwH8S1VrhSxyXAD/pxOaQZVn3g4LvjFMqUK0V03ZPJYEiAfK14Tflcnl4YXbq7zASygV8OE3kjzPz+wBekGB/q3gYnp/Rfw0qEYuADydEsf1fb/0DEA3UwjLhVsKj4QN9tVgLvGutIJTY46Sby36210jEFoFasJSRN4lYSLvTDUfoTzeFwPYOdZ6Y/v/BQVhzhP5i0whs14p+YqSq0MQTjsh+0VQCe4Xd7f19yYEowGMrZFHCHkZA9WwG+X7T58ADaMspQEzzuR8AAAAASUVORK5CYII=) !important;
    width: 14px !important;
    height: 14px !important;
}
.m-calendar .m-toolbar .m-month-selector .m-next-btn, .m-calendar .m-toolbar .m-year-selector .m-next-btn{
  background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADhUlEQVRoQ+2ZS2xMURjH/9+dqSqJYFVBLMSOICTCBvGIBAsSFtJJDYnEo01aM507Su+5V3Vm7h31JjYk3kMiYknK0kqkuhUbrzULLW3nk1PEzK3FOPfcqUl61+fx+33fd86591xCjT9U4/yYFJjoDE5moCYzkBCZjQQ6C+CtAdzJCfPeRIkolVDSyj4HsO43NBG1uCJ1cSIkVAVeAVhWCkzEtivSotoSagLC3QYUH4JRVwZMuOQJ80g1JZQEJGBHV24DE98C0FguQYWRz3XxM2faB6shoiwg4ZLWqWVA9CbAi32Z6BsdHon3njr+LmyJQAJjmRC5eczFWwCtLYVlRn+ROd57Mi3XS2hPYAFJ1tJyvr5+9tc7BOwsl+APBoy466SehmWgReA3XNLKXQX4QBks4xtgxD2n424YEloFJGDCyvQQKD0OltHqOeYF3RLaBcYkRLadGKf/Aut4tmnplAhF4Nc2G2PiG35YAl127dRhXRKhCYxts8LdAi7K2p9Zvi74wTQaarJt+3tQkVAFJJzpZFaMjlABhIW+xf2ciJpcO/UxiEToAhLuaGf3AqMuWgBjlU9igI1IU14kX6tKVEVAwh0QYtqM4tT7RNjqO/A+GaCY66T6VCSqJvDnrMheB7DXl4lhMoq7XXHs0b9KVF3g5zabc4k56YN96dnmyhoRyLjE5BOgF56dWvPfCyRE9hox4jVXQm29vQ3RL9/lTrTdF+WPTBzLi/Szf42+bF+VNdDefXp+ZHikAPDqUkgC+imCWK7LHFCBr4qA6WSWj45SAcAiX9n01dXXx3o62z6pwocu0GHnNjGzLJtZvsjfa8Bg83/9KpEQ2T3EuD0uuoQLnjBbg0TdFwxdQ/0ZJyF6WomNc3+BtzxhOjpn1L6IEyLjENOJcZCMQ55jXtEJr30NJEX2MhgHfZBDTGjOC/O+bnhtApZlTfmKBnlHtMsH+Z6Jm1X3+EqEA5dQW2f33GhU3g1hfemEDLyKFBHPnTT7KwFRbRNIoP1EdmnEgIRf4gN4QkT7XZF6rwpWaT9lAXm1WDT4JjHmlB9QfHe60bhPiPhQpRBB2ikJJLoyO8ggeUD5L3e17vGViCkJJEX2Dbj8G5eZRN5J2ZVMqrONqsDj0rdKJm7Ji3QN/eAQmc1g6pGRZEI+X2u/mHSWQNCxlEoo6KQ6+08K6IymyliTGVCJms4+PwDmGCVAGA4OZwAAAABJRU5ErkJggg==) !important;
    width: 14px !important;
    height: 14px !important;
}
.m-calendar .m-toolbar {
    font-size: 14px !important;
}
.top {
  position: fixed;
  width: 100%;
  top: 0;
  right: 0;
  z-index: 1;
  height: 2.5rem;
}
.padding{
  padding-top: 2.5rem;
}
.nav {
  display: flex;
  color: white;
  height: 2.5rem;
  line-height: 2.5rem;
  /* padding:0.6rem 0 0.4rem; */
    position: fixed;
      width: 100%;
      z-index: 1;
      /* margin-top: 10px; */
}
.left,
.right {
  width: 10%;
  align-self: center;
  margin-top: 10px
}
.content textarea{
  padding: 0 !important;
}
.center {
  width: 80%;
  display: flex;
  /* align-items: center; */
  justify-content: center;
}
.van-swipe__indicator {
  width: 9px;
  height: 9px;
  background-color: white;
  opacity: 1;
}
.van-swipe__indicator:not(:last-child) {
  margin-right: 10px;
}
.van-swipe__indicators {
  left: 80%;
}
.item-title {
  color: #616161;
}
.van-nav-bar {
  background: #ff5d66;
  z-index: 10;
}
.van-nav-bar .van-icon {
  color: white;
  font-size: 2rem;
}
.van-nav-bar__title {
  color: white;
  font-weight: bold;
  font-size: 1.1rem;
}
.van-nav-bar__text {
  color: white;
  font-size: 1rem;
}
.van-cell__title {
  text-align: left;
}
.van-cell__value {
  font-size: 0.9rem;
}
.van-nav-bar__left {
  padding: 0 8px;
}
.van-tabs__line{
  background-color: #79CA50 !important;
}
.van-tab--active {
    font-weight: bold !important;
}
.red{
  background: red !important;
}
.ban{
      background: #eec035 !important;
}
.infos img{
  max-width: 100% !important;
  height: auto !important;
}
.van-search{
      padding: 10px 0 !important;
}
.van-search__content .van-field__control::-webkit-input-placeholder {
                /* Chrome/Opera/Safari */
                color: #7FBB61;
            }
.van-search__content{
  border-radius: 1rem !important;
    border: solid 1px #7FBB61 !important;
    padding-left: 1rem !important;
}
.van-field__left-icon .van-icon{
      font-size: 20px !important;
      color:#7FBB61 !important;
}
.van-field__control{
      color:#7FBB61;
}
</style>



// WEBPACK FOOTER //
// src/App.vue